import classNames from "classnames";
import { ReactNode } from "react";

export interface SubheaderProps {
  tabs?: ReactNode;
  filters?: ReactNode;
  actions?: ReactNode;
  density?: "comfortable" | "compact";
  className?: string;
  sticky?: boolean;
}

export const Subheader = ({
  tabs,
  filters,
  actions,
  density = "comfortable",
  className,
  sticky = false,
}: SubheaderProps) => {
  const isCompact = density === "compact";

  return (
    <div className={classNames(
      "flex flex-col gap-3 font-sans border-b border-primary-200/40 dark:border-primary-800/40 w-full z-10",
      isCompact ? "pb-2" : "pb-4",
      sticky && "sticky top-0 bg-white/80 dark:bg-base-900/80 backdrop-blur-md pt-2",
      className
    )}>
      {tabs && (
        <div className="w-full">
          {tabs}
        </div>
      )}
      {(filters || actions) && (
        <div className="flex flex-col md:flex-row gap-3 items-start md:items-center justify-between w-full">
          {filters && <div className="flex flex-1 flex-wrap items-center gap-2">{filters}</div>}
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      )}
    </div>
  );
};
